import React, { forwardRef } from 'react';
import type { TableCellProps } from '@mui/material';
import { TableCell as TableCellMUI } from '@mui/material';

import { omitUndefinedProps } from '@/mui/helpers';

import { CUSTOM_ATTRIBUTE_NO_WRAP, CUSTOM_AUTO_WIDTH } from './TableCell.api';

type Props = {
  noWrap?: boolean;
  autoWidth?: boolean;
};

const TableCell = forwardRef<HTMLElement, TableCellProps & Props>((props, ref) => {
  const props$ = omitUndefinedProps({
    ...props,
    noWrap: undefined,
    autoWidth: undefined,
    [CUSTOM_ATTRIBUTE_NO_WRAP]: props.noWrap ? '' : undefined,
    [CUSTOM_AUTO_WIDTH]: props.autoWidth ? '' : undefined,
  }) as TableCellProps;

  if (props$.padding === 'checkbox' && !props$.align) {
    props$.align = 'center';
  }

  return <TableCellMUI {...props$} ref={ref} />;
});

TableCell.displayName = 'TableCell';

export default TableCell;
